import template from './main_menu.html'

export default {
  template,
  controller: 'mainMenuController as mainMenu'
}
